import { render, staticRenderFns } from "./IuvActivityShare.vue?vue&type=template&id=088f7b37&scoped=true"
import script from "./IuvActivityShare.vue?vue&type=script&lang=js"
export * from "./IuvActivityShare.vue?vue&type=script&lang=js"
import style0 from "./IuvActivityShare.vue?vue&type=style&index=0&id=088f7b37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088f7b37",
  null
  
)

export default component.exports